var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    theme: "light",
    className: "sc-RefOD dEBIWO",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.9494942,4.41421356 L7.99974671,9.36396103 L3.04999924,4.41421356 L4.4642128,3 L7.99974671,6.53553391 L11.5352806,3 L12.9494942,4.41421356 Z M3,9.91421356 L13,9.91421356 L13,11.9142136 L3,11.9142136 L3,9.91421356 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.8efa7edbf08bbae3b7eb55ceedfb4634.svg";
export { ForwardRef as ReactComponent };